<template>
  <div :class="colSpan">
    <!-- LABEL -->
    <label
      :for="handle || field.handle"
      class="mb-2 block text-grey-300 typo-subtitle"
    >
      {{ shouldTranslate ? $t(`forms.${field.handle}`) : (label || field.label || field.display) }}{{ isRequired ? '*' : '' }}
    </label>

    <!-- INPUT -->

    <Field
      :id="handle || field.handle"
      :value="value"
      :name="handle || field.handle"
      :label="label || field.label || field.display"
      :type="type || field.config.input_type || field.type"
      :as="tag"
      :placeholder="placeholderText"
      :disabled="disabled"
      :maxlength="field.config.character_limit || 9999"
      :rules="
        field.config.input_type === 'tel'
          ? `${rulesAsString}|phone`
          : rulesAsString
      "
      :class="[{ 'min-h-32': (type || field.type) === 'textarea' }, error ? 'border-error' : 'border-black']"
      class="w-full border-b bg-grey-100 p-4 focus:border-black"
      rows="4"
      :autocomplete="autocomplete"
    />

    <!-- ERROR -->
    <FieldError :error="error" />
  </div>
</template>

<!-- eslint-disable-next-line vue/block-lang -->
<script setup>
import { Field } from 'vee-validate'

const props = defineProps({
  handle: {
    type: String,
    default: null,
  },
  field: {
    type: Object,
    default: null,
  },
  value: {
    type: null,
    default: '',
  },
  placeholder: {
    type: String,
    default: '',
  },
  rules: {
    type: [Array, String],
    default: '',
  },
  error: {
    type: String,
    default: null,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  label: {
    type: String,
    default: '',
  },
  type: {
    type: String,
    default: null,
  },
  width: {
    type: [Number, String],
    default: null,
  },
  autocomplete: {
    type: String,
    default: null,
  },
})

const shouldTranslate = inject('shouldTranslate', false)

const tag = computed(() => {
  if ((props.type || props.field?.type) === 'textarea') {
    return 'textarea'
  }

  return 'input'
})

const rulesAsString = useFilterVeeValidateRules(props.rules)

const isRequired = computed(() => {
  return props.rules.includes('required')
})

const colSpan = computed(() => {
  const width = parseInt(props.width) || props.field?.width || 100

  switch (width) {
    case 25:
      return 'md:col-span-6 lg:col-span-3 col-span-12'
    case 33:
      return 'md:col-span-6 lg:col-span-4 col-span-12'
    case 50:
      return 'md:col-span-6 lg:col-span-6 col-span-12'
    case 66:
      return 'md:col-span-6 lg:col-span-8 col-span-12'
    default:
      return 'lg:col-span-12 col-span-12'
  }
})

const placeholderText = computed(() => {
  return (
    props.placeholder || props.field?.config?.placeholder
  )
})
</script>

<style scoped>
input[type='date']::-webkit-inner-spin-button,
input[type='date']::-webkit-calendar-picker-indicator {
  display: none;
  -webkit-appearance: none;
}
</style>
